import { render, staticRenderFns } from "./Firmware.vue?vue&type=template&id=2c770026&scoped=true&"
import script from "./Firmware.vue?vue&type=script&lang=js&"
export * from "./Firmware.vue?vue&type=script&lang=js&"
import style0 from "./Firmware.vue?vue&type=style&index=0&id=2c770026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c770026",
  null
  
)

export default component.exports